module.exports = __webpack_public_path__ + "static/media/furniture.89fecb73.png";